const {
  JsonSerializer,
} = require("@cyclonedx/cyclonedx-library/dist.node/serialize/jsonSerializer.js");
const JSON = require("@cyclonedx/cyclonedx-library/dist.node/serialize/json/index.js");

module.exports = {
  JsonSerializer,
  JSON,
};
